import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { loadEvents, loadMoreEvents } from 'console/tabs/events/redux/actions';
import { select_device_events } from 'console/tabs/events/redux/selectors';
import { useMounted } from 'shared/hooks/utils';
import { useAction, useAppSelector, usePartialAppSelector, } from 'shared/hooks/redux/hooks';
import { todayEndToUnix, todayStartToUnix } from 'webui/utils/unixtime';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getStaleState } from 'console/idle/selectors';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const useLoadDeviceEvents = (device_id, active = true) => {
    const isMounted = useMounted();
    const stale = useAppSelector(getStaleState);
    const onLoadEvents = useAction(loadEvents);
    const event_state = usePartialAppSelector(select_device_events, device_id);
    const { loading, error, loaded } = event_state;
    const { mintime, maxtime } = useAppSelector((state) => state.period);
    useEffect(() => {
        if (isMounted.current && active) {
            if (device_id == null) {
                return;
            }
            //Если ошибка в загрузке трека, то, чтобы не грузить те же события
            if (error != null) {
                return;
            }
            //Если загружаются
            if (loading) {
                return;
            }
            if (!loaded) {
                onLoadEvents(mintime, maxtime, device_id);
            }
        }
    }, [maxtime, mintime, active, device_id, error, loaded]);
    useEffect(() => {
        if (isMounted.current && active && !stale && event_state.loaded) {
            if (device_id == null) {
                return;
            }
            onLoadEvents(mintime, maxtime, device_id);
        }
    }, [stale]);
    return event_state;
};
export const useScrollDeviceEvents = (device_id) => {
    const [lastRowInView, setLastRowInView] = useState(false);
    const [is_next_batch_loading, setNextBatchIdle, setNextBatchLoading] = useBooleanState(false);
    const lastRowRef = useRef(null);
    const period = useAppSelector((state) => state.period);
    const { have_more, batches, loading } = usePartialAppSelector(select_device_events, device_id);
    const onLoadMoreEvents = useAction(loadMoreEvents);
    useEffect(() => {
        if (is_next_batch_loading && have_more) {
            requestAnimationFrame(() => {
                if (device_id !== null) {
                    const lastEvent = batches.at(-1)?.localizedEvents.at(-1);
                    onLoadMoreEvents(period.mintime ?? todayStartToUnix(), period.maxtime ?? todayEndToUnix(), device_id, lastEvent);
                    setNextBatchIdle();
                }
            });
        }
    }, [is_next_batch_loading, setNextBatchIdle]);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => setLastRowInView(entries[0].isIntersecting), {
            threshold: 0.1,
        });
        if (lastRowRef.current) {
            observer.observe(lastRowRef.current);
        }
        return () => {
            observer.disconnect();
        };
    });
    useEffect(() => {
        if (lastRowInView && !loading) {
            setNextBatchLoading();
        }
    }, [lastRowInView]);
    const anchor = useMemo(() => (have_more ? _jsx(Box, { ref: lastRowRef }) : null), [lastRowRef, have_more]);
    return anchor;
};
